import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { getApiCall } from "../../../service/httpCall";
import Loader from "../../../components/partials/components/loader";
import '@fortawesome/fontawesome-free/css/all.min.css';
import "../../../assets/custom/css/custom.css";
import { API_OUTCOMING_SUMMARY_LIST, DOWNLOAD_REPORT, API_INCOMING_REPORT_BY_DID_LIST } from '../../../service/url';
import { postApiCall } from '../../../service/httpCall';
import LottieAnimation from '../../../components/lottie/lottie';
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import moment from 'moment';
import { getUser } from "../../../utilities/setting";
import { useNavigate } from 'react-router-dom';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { toast } from "react-toastify";
import { loadPortalReportData, PORTAL_REPORT_RESOURCES } from "../../../utilities/portalReportRefresh";
import { Storage } from "../../../utilities/setting";

export const formatDateTime = (dateString) => {
  if (!dateString) return "";
  const isoString = dateString.replace(" ", "T") + "Z";
  const date = new Date(isoString);
  const istString = date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    hour12: false,
  });
  const [datePart, timePart] = istString.split(", ");
  const [day, month, year] = datePart.split("/");
  return `${year}-${month}-${day} ${timePart}`;
};

const getDefaultDates = () => {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date();
  return { start, end };
};

const dateToInputStr = (d) => {
  if (!d) return "";
  const dt = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(dt.getTime())) return "";
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

const inputStrToLocalDate = (str) => {
  if (!str) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(str);
  if (!m) {
    const d = new Date(str);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
};


const OutcomingSummary = () => {
  const [outcomingSummary, setOutcomingSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [showSidePanel, setShowSidePanel] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const { start, end } = getDefaultDates();
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [selectedDid, setSelectedDid] = useState(null);
  const [didOptions, setDidOptions] = useState([]);
  const [showToastModal, setShowToastModal] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [outcomingReport, setOutcomingReport] = useState([]);
  const [detailStartDate, setDetailStartDate] = useState('');
  const [detailEndDate, setDetailEndDate] = useState('');
  const [detailDid, setDetailDid] = useState(null);
  const navigate = useNavigate();
  const [loggedInUserId, setLoggedInUserId] = useState(null);
  const [usernames, setUsernames] = useState([]);
  const [selectedUsername, setSelectedUsername] = useState(null);
  const [loggedInUserRole, setLoggedInUserRole] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const rawUser = Storage.getItem('user');

      if (!rawUser) {
        console.error("User data not found in Storage");
        return;
      }

      let user;
      try {
        user = JSON.parse(rawUser);

        if (user) {
          setLoggedInUserId(user?.id);
          setLoggedInUserRole(user?.role);
        }
      } catch (e) {
        console.error("Invalid JSON in Storage user:", e);
        return;
      }
    };
    fetchUserData();
  })


  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .custom-scrollbar-panel::-webkit-scrollbar {
        width: 20px;
      }

      .custom-scrollbar-panel::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      .custom-scrollbar-panel::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 8px;
      }

      .custom-scrollbar-panel::-webkit-scrollbar-thumb:hover {
        background: #555;
      }

      .custom-scrollbar-panel {
        scrollbar-width: auto; /* for Firefox */
        scrollbar-color: #888 #f1f1f1;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});

  useEffect(() => {
    const user = getUser();
    if (user) {
      if (user?.acl_settings) {
        setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
      }
    }
  }, []);

  useEffect(() => {
    const onAclRefreshed = () => {
      const user = getUser();
      if (user?.acl_settings?.module_operations) {
        try {
          const parsed = typeof user.acl_settings.module_operations === "string"
            ? JSON.parse(user.acl_settings.module_operations)
            : user.acl_settings.module_operations;
          setModuleOperationsForReadPermissionCheck(parsed);
        } catch (e) {
          console.log("Failed to apply refreshed ACL", e);
        }
      }
    };
    window.addEventListener("acl-refreshed", onAclRefreshed);
    return () => window.removeEventListener("acl-refreshed", onAclRefreshed);
  }, []);


  const showToasts = (message) => {
    setToastMessage(message);
    setShowToastModal(true);

    setTimeout(() => {
      setShowToastModal(false);
    }, 3000);
  };

  const handleFilter = () => {
    const start = startDate
      ? moment(startDate).format("YYYY-MM-DD")
      : null;

    const end = endDate
      ? moment(endDate).format("YYYY-MM-DD")
      : null;

    fetchOutcomingSummary(start, end, true);
  };

  const handleExport = async () => {
    try {
      exportToCSV({
        fileName: "outcoming-summary",
        data: filteredData,
        columns: [
          {
            header: "Did",
            accessor: "did"
          },
          {
            header: "User Id",
            accessor: "user_id"
          },
          {
            header: "Username",
            accessor: "user_username"
          },
          {
            header: "Schedule Date",
            accessor: (row) =>
              formatDateTime(row.schedule_date)
          },
          {
            header: "Total Nos",
            accessor: "nos_processed"
          },
          {
            header: "Connected Calls",
            accessor: "connected_calls"
          },
          {
            header: "SMS Count",
            accessor: "sms_count"
          },
          {
            header: "Billing Duration",
            accessor: "billing_duration"
          },
          {
            header: "DTMF Count",
            accessor: "dtmf_count"
          },
          {
            header: "Retry Count",
            accessor: "retry_count"
          },
          {
            header: "Webhook Count",
            accessor: (row) =>
              row.webhook_count || 0
          }
        ]
      });
    } finally {
    }
  };

  const applyOutcomingSummaryList = (resp) => {
    if (!resp) {
      return;
    }

    const updatedList = resp.map((val, idx) => {
      val["key"] = idx + 1;
      return val;
    });

    setOutcomingSummary(updatedList);
    setFilteredData(updatedList);

    const uniqueDids = [
      ...new Set(updatedList.map((item) => item.did)),
    ].map((did) => ({ label: did, value: did }));

    const uniqueUsers = [
      ...new Set(updatedList.map((item) => item.user_username)),
    ].map((u) => ({ label: u, value: u }));

    setDidOptions(uniqueDids);
    setUsernames(uniqueUsers);
  };

  const fetchOutcomingSummary = async (start, end, force = false) => {
    if (!loggedInUserId || !loggedInUserRole) {
      return;
    }

    setLoading(true);
    const startDate =
      start || moment().startOf("month").format("YYYY-MM-DD");
    const endDate =
      end || moment().format("YYYY-MM-DD");

    try {
      const result = await loadPortalReportData({
        resource: PORTAL_REPORT_RESOURCES.OUTCOMING_SUMMARY_LIST,
        userId: loggedInUserId,
        role: loggedInUserRole,
        params: { start_date: startDate, end_date: endDate },
        force,
        onBlocked: (remainingMs) => {
          toast.info(
            `Outcoming summary can be refreshed after ${Math.ceil(remainingMs / 1000)} seconds.`
          );
        },
        fetchFn: () =>
          getApiCall(
            `${API_OUTCOMING_SUMMARY_LIST}?start_date=${startDate}&end_date=${endDate}`
          ),
      });
      applyOutcomingSummaryList(result.data);
    } catch (error) {
      toast.error(JSON.stringify(error) || "Failed to fetch outcoming summary");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (loggedInUserId && loggedInUserRole) {
      fetchOutcomingSummary();
    }
  }, [loggedInUserId, loggedInUserRole]);

  const handleReset = () => {
    const { start, end } = getDefaultDates();

    setStartDate(start);
    setEndDate(end);
    setSelectedDid(null);
    setSelectedUsername(null);

    fetchOutcomingSummary(
      moment(start).format("YYYY-MM-DD"),
      moment(end).format("YYYY-MM-DD"),
      true
    );
  };

  const downloadFile = (rowData) => {
    if (!rowData) {
      console.error("Row data is missing.");
      return;
    }

    const params = {
      did: rowData.did,
      user_id: loggedInUserId,
      status: 0,
      report_type: 'full',
      schedule_date: rowData.schedule_date,
    }

    postApiCall(DOWNLOAD_REPORT, params)
      .then(onDownloadReportCreateSuccess)
      .catch(onDownloadReportCreateError);

    function onDownloadReportCreateSuccess(resp) {
      showToasts('Your Report Generation is in-progress')
    }

    function onDownloadReportCreateError(err) {
      toast.error(JSON.stringify(err));
    }
  };


  const actionBodyTemplate = (rowData) => {
    return (
      <div className="d-flex justify-space-between gap-2">
        <button
          className="btn-icons m-1"
          onClick={() => downloadFile(rowData)}
          style={{ marginLeft: '8px', border: 'none', background: 'none', padding: '0' }}
        >
          <i className="fa fa-download" aria-hidden="true" style={{ color: 'blue', fontSize: '24px' }}></i>
        </button>
        <button
          className="btn-icons m-1"
          onClick={() => viewDetails(rowData)}
          style={{ border: 'none', background: 'none', padding: '0' }}
        >
          <i className="fa fa-eye" aria-hidden="true" style={{ color: 'blue', fontSize: '24px' }}></i>
        </button>
      </div>
    );
  };

  useEffect(() => {
    let filtered = [...outcomingSummary];

    if (selectedDid) {
      filtered = filtered.filter((d) => d.did == selectedDid);
    }

    if (selectedUsername) {
      filtered = filtered.filter(
        (d) => d.user_username === selectedUsername
      );
    }

    setFilteredData(filtered);
  }, [outcomingSummary, selectedDid, selectedUsername]);

  const canRead = hasPermission(
    moduleOperationsForReadPermissionCheck,
    "Outcoming Summary",
    "read",
  );

  if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
    return (
      <div
        className="text-center p-4"
        style={{
          marginTop: "50px",
          marginBottom: "50px",
          fontSize: "16px",
        }}
      >
        No read permission found in assigned ACL
      </div>
    );
  }

  if (loading) {
    return <Loader />;
  }

  const viewDetails = (rowData) => {
    const scheduleDate = rowData?.schedule_date;
    const kolkataOffset = 330;

    const utcDateOnly = moment.utc(scheduleDate).format('YYYY-MM-DD');
    setDetailDid(rowData.did);
    const defaultStartDate = moment.utc(`${utcDateOnly} 00:00:00`).utcOffset(kolkataOffset, true).format('YYYY-MM-DD HH:mm:ss');
    const defaultEndDate = moment.utc(`${utcDateOnly} 23:59:59`).utcOffset(kolkataOffset, true).format('YYYY-MM-DD HH:mm:ss');

    navigate(`/did-report/${rowData.did}/${defaultStartDate}/${defaultEndDate}`);
  };

  const handleDetailFilter = () => {
    getApiCall(`${API_INCOMING_REPORT_BY_DID_LIST}/${detailDid}/${detailStartDate}/${detailEndDate}`)
      .then((resp) => {
        if (resp) {
          setOutcomingReport(resp);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    setShowSidePanel(true);
  };

  const handleDetailClearFilter = (rowData) => {
    viewDetails(rowData);
  };

  return (
    <>
      <div>
        <div className="card" style={{ marginTop: "20px" }}>
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="card-title">Outcoming Summary</h4>
            {filteredData.length > 0 &&
              <Button
                label="Export Data"
                onClick={handleExport}
                className="p-button-active p-button-sm"
                style={{ marginBottom: "10px", marginLeft: "10px" }}
              />
            }
          </div>
          <div className="card-body">
            <div className="d-flex align-items-center mb-3" style={{ marginLeft: "10px" }}>
              <Form.Control
                type="date"
                value={dateToInputStr(startDate)}
                min={dateToInputStr(moment().subtract(6, "months").toDate())}
                max={dateToInputStr(new Date())}
                placeholder="Start Date"
                onChange={(e) => setStartDate(inputStrToLocalDate(e.target.value))}
                style={{ width: "170px", flexShrink: 0 }}
              />
              <span className="mx-2">to</span>
              <Form.Control
                type="date"
                value={dateToInputStr(endDate)}
                min={dateToInputStr(startDate)}
                max={dateToInputStr(new Date())}
                placeholder="End Date"
                onChange={(e) => setEndDate(inputStrToLocalDate(e.target.value))}
                style={{ width: "170px", flexShrink: 0 }}
              />
              <Form.Select
                value={selectedDid || ""}
                onChange={(e) =>
                  setSelectedDid(e.target.value || null)
                }
                className="mx-2"
                style={{ width: "200px" }}
              >
                <option value="">Select DID</option>
                {didOptions.map((did) => (
                  <option
                    key={did.value}
                    value={did.value}
                  >
                    {did.label}
                  </option>
                ))}
              </Form.Select>

              <Form.Select
                value={selectedUsername || ""}
                onChange={(e) =>
                  setSelectedUsername(e.target.value || null)
                }
                className="mx-2"
                style={{ width: "200px" }}
              >
                <option value="">Select Username</option>
                {usernames.map((user) => (
                  <option
                    key={user.value}
                    value={user.value}
                  >
                    {user.label}
                  </option>
                ))}
              </Form.Select>
              <Button
                label="Filter"
                onClick={handleFilter}
                className="p-button-sm p-button-primary mx-2"
              />
              <Button
                label="Reset"
                onClick={handleReset}
                className="p-button-sm p-button-secondary"
              />
            </div>
            <div className="scroll-container">
              <DataTable
                value={filteredData}
                paginator
                rows={10}
                tableStyle={{ minWidth: "50rem" }}
              >
                <Column field="did" header="Did" filterPlaceholder="Search by name" />
                <Column field="user_id" header="User Id" filterPlaceholder="Search by URL" />
                <Column field="user_username" header="Username" filterPlaceholder="Search by URL" />
                <Column
                  field="schedule_date"
                  header="Schedule Date"
                  body={(rowData) => formatDateTime(rowData.schedule_date)}
                />
                <Column field="nos_processed" header="Total Nos" filterPlaceholder="Search by category" />
                <Column field="connected_calls" header="Connected Calls" filterPlaceholder="Search by URL" />
                <Column field="sms_count" header="SMS Count" filterPlaceholder="Search by duration" />
                <Column field="billing_duration" header="Billing Duration" filterPlaceholder="Search by category" />
                <Column field="dtmf_count" header="Dtmf Count" filterPlaceholder="Search by category" />
                <Column field="retry_count" header="Retry Count" filterPlaceholder="Search by category" />
                <Column field="webhook_count" header="Webhook Count" filterPlaceholder="Search by category" body={(rowData) => rowData.webhook_count || 0} />
                <Column
                  header="Actions"
                  body={actionBodyTemplate}
                  style={{ textAlign: "center", width: "12rem" }}
                />
              </DataTable>
            </div>
          </div>
        </div>
        <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
          <Modal.Body className="text-center">
            <h5>{toastMessage}</h5>
            <LottieAnimation animationData={"https://assets6.lottiefiles.com/packages/lf20_touohxv0.json"} />
          </Modal.Body>
        </Modal>
      </div>

      {showSidePanel && (
        <div
          className="custom-scrollbar-panel"
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: '1500px',
            height: '100%',
            backgroundColor: '#fff',
            borderLeft: '1px solid #ddd',
            boxShadow: '-2px 0 5px rgba(0,0,0,0.1)',
            zIndex: 1050,
            overflowY: 'auto',
            transition: 'transform 0.3s ease-in-out',
            padding: '15px',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px',
            }}
          >
            <h5 style={{ margin: 0 }}>Detail View</h5>
            <button
              onClick={() => setShowSidePanel(false)}
              style={{
                border: 'none',
                backgroundColor: '#dc3545',
                color: '#fff',
                borderRadius: '3px',
                padding: '5px 10px',
                cursor: 'pointer',
              }}
            >
              <i className="fa fa-times" aria-hidden="true" style={{ fontSize: '16px' }}></i>
            </button>
          </div>

          <div>
            <p><strong>DID:</strong> {selectedRow?.did}</p>
            <p><strong>User ID:</strong> {selectedRow?.user_id?.id}</p>
            <p><strong>Schedule Date:</strong> {new Date(selectedRow?.schedule_date).toUTCString()}</p>
            <p><strong>Nos Processed:</strong> {selectedRow?.nos_processed}</p>
            <p><strong>Connected Calls:</strong> {selectedRow?.connected_calls}</p>
            <p><strong>Total Nos:</strong> {selectedRow?.total_nos}</p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label><strong>Start Date:</strong></label>
              <input
                type="datetime-local"
                value={detailStartDate}
                onChange={(e) => setDetailStartDate(e.target.value)}
                style={{ padding: '5px', minWidth: '220px' }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label><strong>End Date:</strong></label>
              <input
                type="datetime-local"
                value={detailEndDate}
                onChange={(e) => setDetailEndDate(e.target.value)}
                style={{ padding: '5px', minWidth: '220px' }}
              />
            </div>

            <button
              onClick={handleDetailFilter}
              style={{
                marginTop: '22px',
                padding: '7px 12px',
                backgroundColor: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Filter
            </button>

            <button
              onClick={() => handleDetailClearFilter(selectedRow)}
              style={{
                marginTop: '22px',
                padding: '7px 12px',
                backgroundColor: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Clear Filter
            </button>
          </div>

          <div className="scroll-container">
            <DataTable
              value={outcomingReport}
              paginator
              rows={10}
              tableStyle={{ minWidth: "50rem" }}
            >
              <Column field="user_id" header="User Id" filterPlaceholder="Search by URL" />
              <Column field="caller_number" header="Caller Number" filterPlaceholder="Search by category" />
              <Column field="callee_number" header="Callee Number" filterPlaceholder="Search by name" />
              <Column
                field="start_time"
                header="Start Time"
                body={(rowData) =>
                  new Date(rowData.start_time).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })
                }
              />
              <Column
                field="end_time"
                header="End Time"
                body={(rowData) =>
                  new Date(rowData.end_time).toLocaleString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })
                }
              />
            </DataTable>
          </div>
        </div>
      )}
    </>
  );
};

export default OutcomingSummary;